var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "qty-box d-flex h-100" }, [
    _c(
      "select",
      {
        staticClass: "qty-input",
        attrs: {
          disabled: _vm.waiting,
          "aria-label": _vm.$translate("Ceres::Template.itemQuantityInput"),
        },
        domProps: { value: _vm.displayValue },
        on: {
          change: function ($event) {
            return _vm.setValue($event.target.value)
          },
        },
      },
      _vm._l(_vm.configMaxValue, function (index) {
        return _c("option", { key: index }, [_vm._v(" " + _vm._s(index))])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }